export const toastMessage = {
  SAVED_SUCCESS: 'Saved successfully!',
  UPDATED_SUCCESS: 'Updated successfully!',
  CONTENT_INVALID: 'Content invalid',
  ERROR_SAVING: 'Error while saving',
  ERROR_UPDATING: 'Error while updating',
  SOMETHING_WENT_WRONG: 'Something went wrong!',
  ERROR_DELETING: 'Error while deleting',
  DELETED_SUCCESS: 'Deleted successfully!',
};
